import * as React from 'react';
import TablePagination from '@mui/material/TablePagination';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import * as locales from '@mui/material/locale';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/TablePagination": TablePagination, "@mui/material/Autocomplete": Autocomplete, "@mui/material/Box": Box, "@mui/material/TextField": TextField, "@mui/material/styles": { createTheme, ThemeProvider, useTheme }, "@mui/material/locale": locales } } });
export default ClientProvider;
